import { useQuery } from '@tanstack/react-query';

import { getActiveDeliverySettings } from 'apis/delivery-settings-api/api';
import { FeatureType } from 'common/types';

type UseDeliverySettingsProps = {
  featureId: string;
  feature?: FeatureType;
};

const useDeliverySettings = ({ featureId, feature }: UseDeliverySettingsProps) => {
  const { data: activeDeliverySettings } = useQuery(
    [`delivery-settings/${featureId}`],
    () => getActiveDeliverySettings(featureId),
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: feature && feature === 'venue',
    },
  );

  return activeDeliverySettings?.activeDeliverySettingsType;
};

export default useDeliverySettings;
